import { type ClassValue, clsx } from 'clsx'
import { mapValues } from 'remeda'
import { twMerge } from 'tailwind-merge'

import type { NextPageSearchParams } from './handy-types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const safeJSONParse = (value: unknown, onErrorReturn: unknown) => {
  try {
    return JSON.parse(String(value))
  } catch {
    return onErrorReturn
  }
}

export const safeParseURLParam = (value: string | string[] | undefined): unknown => {
  try {
    if (typeof value === 'string') {
      return JSON.parse(value)
    }
    return value
  } catch {
    return value
  }
}

/** Web compatible method to create a hash, using SHA256 */
export const createHash = async (message: string) => {
  const data = new TextEncoder().encode(message)
  const hash = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .toString()
}

/** Web compatible method to create a random string of a given length */
export const randomString = (size: number) => {
  const i2hex = (i: number) => ('0' + i.toString(16)).slice(-2)
  const r = (a: string, i: number): string => a + i2hex(i)
  const bytes = crypto.getRandomValues(new Uint8Array(size))
  return Array.from(bytes).reduce(r, '')
}

export const safeParseURLParams = (searchParams: NextPageSearchParams) => {
  return mapValues(searchParams, safeParseURLParam)
}

export const removeTrailingSlash = (str: string) => (str.endsWith('/') ? str.slice(0, -1) : str)

// TODO: Do extensive checking, Jano saying as it works and I believe him, but it looks some extraordinary complex
export const shuffleArray = <T>(array: T[]): T[] => {
  const newArray = [...array] // Create a shallow copy to avoid mutating the original array
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    // Safely swap the elements
    ;[newArray[i], newArray[j]] = [newArray[j]!, newArray[i]!]
  }
  return newArray
}
